import { Organization } from '@prisma/client'
import dayjs from 'dayjs'
import { Api } from '~/core/trpc'

type Props = {
  organization: Organization
}

export const useData = ({ organization }: Props) => {
  const period = dayjs().format('YYYY-MM')
  const metricsQuery = Api.organizationMetrics.findUnique.useQuery(
    {
      where: {
        organizationId_period: {
          organizationId: organization.id,
          period,
        },
      },
    },
    {
      enabled: !!organization.id,
    },
  )

  return {
    metrics: metricsQuery.data,
  }
}
